import React from 'react';
import { Wand16Regular } from '@fluentui/react-icons';
import styles from './irlEvidence.module.css';

/**
 * Premium intelligence CTA for IRL detail sidebar when a management response exists.
 * Opens validation column in ResponseDetailSidebar (split layout).
 */
const FindEvidenceButton = ({ onOpenEvidence, evidenceOpen }) => {
    if (!onOpenEvidence) return null;

    return (
        <div className={styles.findEvidenceStrip}>
            <button
                type="button"
                className={`${styles.findEvidenceBtn}${evidenceOpen ? ` ${styles.findEvidenceBtnActive}` : ''}`}
                onClick={() => onOpenEvidence(true)}
                aria-label="Find evidence for management response"
                aria-pressed={evidenceOpen}>
                <Wand16Regular />
                Find Evidence
            </button>
        </div>
    );
};

export default FindEvidenceButton;
